import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import ManualFormTitleStrip from "../../../../../common_components/ManualFormTitleStrip";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { toastError, toastSuccess, BASE_URL } from "../../../../../utils/constants";
import { insertUpdateRentalAudioAndVideo_action, getRentalAudioAndVideoDetails_action } from '../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/rentalAudioAndVideo_action/rentalAudioAndVideo_action'
import $ from 'jquery'
import moment from "moment";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";
import VendorDetails from "../../vendorDetails";

class RentalAudioAndVedioEquipment extends Component {
  constructor(props) {
    super(props)
    this.state = {
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      isLoading: false,
      isExistingForm: false,
      Is_Agree: false,
      Remark: "",
      CGST: 0,
      SGST: 0,
      IGST: 0,
      IsIGST: 0,
      Is_AgreeErr: "",
      DeadlineDate: "",
      Is_Required: true,
      currentDate: moment().format("DD-MM-YYYY"),
      tableList: [],
      totalAmount: 0,
      agencyName: "",
      agencyEmail: "",
      exhibitorName: "",
      hallNo: "",
      stallNo: "",
      stallArea: "",
      stallType: "",
      openSides: "",
      Requirement: "",
      contactDetailsList: [],
      url: "",
      StatusID: "",
      CurrencyID: 1,
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      is_View: false,
      exhDetails: {},
    };

    this.handleConfirmation = this.handleConfirmation.bind(this)
  }

  handleConfirmation(flag) {
    const { confirmationObj } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.addRentalAndVideoEquipment()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  componentDidMount() {
    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      StatusID:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.StatusID != ""
          ? this.props.location.state.StatusID
          : "",
      is_View:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,
      exhDetails: {},
    });

    const url = BASE_URL.split('/api')
    this.setState({ url: url[0] })

    this.getRentalAudioAndVideoDetails()
    this.loadscript()
  }

  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  handleCancel() {
    window.history.back()
  }

  inputValidate() {
    const { Is_Agree, tableList } = this.state
    let isValid = true

    const hasQty = tableList.some(r => (parseInt(r.Qty) || 0) > 0)
    if (!hasQty) {
      toastError("Please enter quantity for at least one equipment item.")
      isValid = false
    }

    if (Is_Agree == 0 || Is_Agree == false) {
      this.setState({ Is_AgreeErr: 'kindly agree to disclaimer for rental audio and video equipments' })
      isValid = false
    }

    return isValid
  }

  getRentalAudioAndVideoDetails() {
    this.setState({ isLoading: true })
    this.props
      .getRentalAudioAndVideoDetails_action()
      .then((data) => {
        if (data.error != 1) {
          const exhInfo = data.ExhibitorDetails && data.ExhibitorDetails.length > 0
            ? data.ExhibitorDetails[0]
            : {}
          const currencyID = exhInfo.CurrencyID || 1

          this.setState({
            isLoading: false,
            contactDetailsList: data.AgencyDetails || [],
            exhDetails: exhInfo,
            exhibitorName: exhInfo.CompanyName || '',
            hallNo: exhInfo.HallName || '',
            stallNo: exhInfo.StallName || '',
            stallArea: exhInfo.StallArea || '',
            stallType: exhInfo.StallTypeName || '',
            openSides: exhInfo.OpenSides || '',
            CurrencyID: currencyID,
            CGST: data.gst && data.gst.length > 0 ? data.gst[0]["CGST"] * 100 : 0,
            SGST: data.gst && data.gst.length > 0 ? data.gst[0]["SGST"] * 100 : 0,
            IGST: data.gst && data.gst.length > 0 ? data.gst[0]["IGST"] * 100 : 0,
            IsIGST: data.gst && data.gst.length > 0 ? (data.gst[0]["IsIGST"] || 0) : 0,
          })

          if (data.data && data.data.length > 0) {
            this.setState({
              isExistingForm: true,
              Remark: data.data[0]['Remark'] || '',
              Is_Agree: data.data[0]['Is_Agree'] || false,
              Requirement: data.data[0]['Comment'] || '',
            })
          }

          // Merge master equipment list with any saved quantities
          const masterList = data.equipmentList || []
          const savedRows = data.getTableDetails || []

          const mergedList = masterList.map(item => {
            const saved = savedRows.find(r => r.RentalAvEquipmentID === item.RentalAvEquipmentID)
            const qty = saved && saved.Qty ? saved.Qty : ""
            const rate = item.Rate || 0
            const amount = qty !== "" ? (parseInt(qty) || 0) * rate : 0
            return {
              ...item,
              Qty: qty,
              Amount: amount,
            }
          })

          this.setState({ tableList: mergedList })
          this.sumTotal(mergedList)
        }
        else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      })
      .catch((e) => {
        console.log(e);
        this.setState({ isLoading: false })
      });
  }

  sumTotal(list) {
    const sum = (list || this.state.tableList).reduce((acc, row) => acc + (row.Amount || 0), 0)
    this.setState({ totalAmount: sum })
  }

  enterQty(e, index) {
    const value = e.target.value.replace(/\D/g, "")

    const tableList = this.state.tableList.map((row, i) => {
      if (i !== index) return row
      const qty = value ? parseInt(value) : 0
      const rate = row.Rate || 0
      return {
        ...row,
        Qty: value || "",
        Amount: qty * rate,
      }
    })

    this.setState({ tableList })
    this.sumTotal(tableList)
  }

  addRentalAndVideoEquipment() {
    const { Remark, Is_Agree, Requirement, tableList } = this.state
    if (!this.inputValidate()) return

    const submitList = tableList.map(row => ({
      RentalAvEquipmentID: row.RentalAvEquipmentID,
      Qty: row.Qty !== "" ? parseInt(row.Qty) : null,
    }))

    this.setState({ isLoading: true })
    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};

    this.props
      .insertUpdateRentalAudioAndVideo_action(
        Requirement,
        Remark,
        Is_Agree,
        ManualFormsID,
        ServiceID,
        VendorDetails,
        submitList,
      )
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          toastSuccess(
            this.state.isExistingForm
              ? "Rental Audio And Video Form Updated Successfully"
              : "Rental Audio And Video Form Saved Successfully"
          );
          setTimeout(() => {
            this.props.navigate("/manualForms");
          }, 2000);
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
        this.setState({ isLoading: false })
      });
  }

  render() {
    const {
      isLoading, isOpenConfirmationModal, Is_Agree, Remark, Is_AgreeErr,
      currentDate, DeadlineDate, tableList, is_View, isHideSection,
      exhibitorName, hallNo, stallNo, stallArea, stallType, openSides,
      Requirement, contactDetailsList, StatusID, exhDetails,
      totalAmount, CGST, SGST, IGST, CurrencyID, IsIGST, isExistingForm,
    } = this.state

    const currency = CurrencyID === 1 ? 'INR' : 'USD'
    const isDeadlinePassed =
      DeadlineDate &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));

    // GST calculations
    const total = Number(totalAmount) || 0
    const cgstRate = Number(CGST) || 0
    const sgstRate = Number(SGST) || 0
    const igstRate = Number(IGST) || 0
    const cgstAmount = Number(((cgstRate / 100) * total).toFixed(2))
    const sgstAmount = Number(((sgstRate / 100) * total).toFixed(2))
    const igstAmount = Number(((igstRate / 100) * total).toFixed(2))
    const grandTotal = IsIGST !== 1
      ? Number((total + cgstAmount + sgstAmount).toFixed(2))
      : Number((total + igstAmount).toFixed(2))

    return (
      <>
        {isOpenConfirmationModal ? (
          <ConfirmationModal
            onConfirmation={this.handleConfirmation}
            message={this.state.confirmationObj}
          />
        ) : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            <ExhibitorHeader />
            <ExhibitorDrawer />
          </>
        )}
        <div className={!isHideSection ? "with-dr-container mf-form" : ""}>
          <div className="">
            {!isHideSection && (
              <div className="row">
                <ExhibitorTopMenu />
              </div>
            )}
{/* Standard page title strip: form name + deadline, sticky under the tab bar */}
{!isHideSection && <ManualFormTitleStrip title={this.props.location?.state?.ManualFormsName || "Rental Audio And Video Equipment"} deadline={this.props.location?.state?.ActualDeadline} />}

            <div>
              <div className="row m-0">
                <div class="card rounded-0 p-0 shadow-none border">
                  <div class="card-header p-2">
                    <h3 class="card-title">Form Instruction</h3>
                  </div>
                  <div class="card-body p-1 m-2">
                    <div style={{ lineHeight: "10px" }}>
                      <p>
                        • Photos/Pictures of the rental equipment, wherever given, are only for
                        demonstration & not actual.{" "}
                      </p>
                      <p>
                        • Exhibitors are requested to contact their respective contractor for
                        technical specifications of the rental audio & Video equipment..
                      </p>

                    </div>

                    {!isHideSection && (
                      <>
                        <strong>
                          <p className="m-0">Exhibitor Details:</p>
                        </strong>
                        <div class="table-responsive mb-3">
                          <table class="table border text-nowrap text-md-nowrap table-bordered mb-0">
                            <tbody>
                              <tr>
                                <td style={{ width: "30%" }}>
                                  <strong>Exhibiting Company Name:</strong>
                                </td>
                                <td>{exhDetails.CompanyName || exhibitorName || "-"}</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Hall No.:</strong>
                                </td>
                                <td>{exhDetails.HallName || hallNo || "-"}</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Booth No.:</strong>
                                </td>
                                <td>{exhDetails.StallName || stallNo || "-"}</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Stall Type:</strong>
                                </td>
                                <td>{exhDetails.StallTypeName || stallType || "-"}</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Area:</strong>
                                </td>
                                <td>{exhDetails.StallArea || stallArea || "-"}</td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Open Sides:</strong>
                                </td>
                                <td>{exhDetails.OpenSides || openSides || "-"}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        {contactDetailsList && contactDetailsList.length > 0 && (
                          <>
                            <strong>
                              <p className="m-0">Agency Contact Details:</p>
                            </strong>
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                              {contactDetailsList.map((data, idx) => (
                                <div
                                  key={idx}
                                  class="table-responsive w-50"
                                  style={{
                                    backgroundColor: "#ebebeb",
                                    marginBottom: "14px",
                                    borderRight: "1px solid lightgray",
                                  }}
                                >
                                  <div style={{ margin: "10px 0 10px 10px", lineHeight: "23px" }}>
                                    {data.AgencyName && (
                                      <p className="m-0">
                                        <strong>Name:</strong> {data.AgencyName}
                                      </p>
                                    )}
                                    {data.Telephone && (
                                      <p className="m-0">
                                        <strong>Phone:</strong> {data.Telephone}
                                      </p>
                                    )}
                                    {data.Fax && (
                                      <p className="m-0">
                                        <strong>Fax:</strong> {data.Fax}
                                      </p>
                                    )}
                                    {data.MobileNo && (
                                      <p className="m-0">
                                        <strong>Mobile No.:</strong> {data.MobileNo}
                                      </p>
                                    )}
                                    {data.AgencyEmailPrimary && (
                                      <p className="m-0">
                                        <strong>Email:</strong> {data.AgencyEmailPrimary}
                                      </p>
                                    )}
                                    {data.AgencyEmailSecondary && (
                                      <p className="m-0">
                                        <strong>Alternate Email:</strong>{" "}
                                        {data.AgencyEmailSecondary}
                                      </p>
                                    )}
                                    {data.AgencyAddress && (
                                      <p className="m-0">
                                        <strong>Address:</strong> {data.AgencyAddress}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </>
                        )}
                      </>
                    )}

                    <VendorDetails />

                    {!isHideSection && (
                      <div className="row mt-4">
                        <h6 className="mt-2 mf-old-deadline">
                          Rental Audio And Video Equipment{" "}
                          <span className="text-danger">
                            Last Date Of Submission -{" "}
                            {this.props.location?.state?.ActualDeadline
                              ? moment(this.props.location.state.ActualDeadline).format(
                                "DD-MM-YYYY",
                              )
                              : "-"}
                          </span>
                        </h6>
                      </div>
                    )}

                    {/* ── Equipment Input Table ── */}
                    <strong>
                      <p className="mt-3 mb-2">Equipment List:</p>
                    </strong>
                    <div class="table-responsive">
                      <table class="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                        <thead>
                          <tr>
                            <th className="text-center">S. No.</th>
                            <th className="text-center">Equipment Description</th>
                            <th className="text-center">Qty</th>
                            {!isHideSection && <th className="text-center">Rate ({currency})</th>}
                            {!isHideSection && <th className="text-center">Amount ({currency})</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {tableList.length > 0 ? (
                            tableList.map((row, i) => (
                              <tr key={row.RentalAvEquipmentID}>
                                <td className="text-center">{i + 1}</td>
                                <td>{row.EquipmentDescription}</td>
                                <td style={{ width: 120 }}>
                                  <input
                                    className="form-control"
                                    type="text"
                                    disabled={is_View || isDeadlinePassed}
                                    value={row.Qty}
                                    onChange={(e) => this.enterQty(e, i)}
                                    maxLength={5}
                                  />
                                </td>
                                {!isHideSection && (
                                  <td className="text-right">
                                    {row.Rate != null ? row.Rate : "-"}
                                  </td>
                                )}
                                {!isHideSection && (
                                  <td className="text-right">{row.Amount || 0}</td>
                                )}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td className="text-center" colSpan={5}>
                                No record found
                              </td>
                            </tr>
                          )}

                          {/* GST and totals – only for exhibitor view */}
                          {!isHideSection &&
                            tableList.length > 0 &&
                            (() => {
                              const colSpan = 2; // S.No + Description
                              return (
                                <>
                                  <tr className="text-right">
                                    <td colSpan={colSpan}></td>
                                    <td colSpan={2}>
                                      <strong>Total (without GST)</strong>
                                    </td>
                                    <td>
                                      <strong>{total.toFixed(2)}</strong>
                                    </td>
                                  </tr>

                                  {IsIGST !== 1 ? (
                                    <>
                                      <tr className="text-right">
                                        <td colSpan={colSpan}></td>
                                        <td colSpan={2}>
                                          <strong>CGST @ {cgstRate}%</strong>
                                        </td>
                                        <td>
                                          <strong>{cgstAmount.toFixed(2)}</strong>
                                        </td>
                                      </tr>
                                      <tr className="text-right">
                                        <td colSpan={colSpan}></td>
                                        <td colSpan={2}>
                                          <strong>SGST @ {sgstRate}%</strong>
                                        </td>
                                        <td>
                                          <strong>{sgstAmount.toFixed(2)}</strong>
                                        </td>
                                      </tr>
                                    </>
                                  ) : (
                                    <tr className="text-right">
                                      <td colSpan={colSpan}></td>
                                      <td colSpan={2}>
                                        <strong>IGST @ {igstRate}%</strong>
                                      </td>
                                      <td>
                                        <strong>{igstAmount.toFixed(2)}</strong>
                                      </td>
                                    </tr>
                                  )}

                                  <tr className="text-right" style={{ backgroundColor: "#eee" }}>
                                    <td colSpan={colSpan}></td>
                                    <td colSpan={2}>
                                      <strong>Grand Total</strong>
                                    </td>
                                    <td>
                                      <strong>{grandTotal.toFixed(2)}</strong>
                                    </td>
                                  </tr>
                                </>
                              );
                            })()}
                        </tbody>
                      </table>
                    </div>

                    {/* Bank details */}
                    {!isHideSection && contactDetailsList && contactDetailsList.length > 0 && (
                      <div className="table-responsive mt-3">
                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                          <thead>
                            <tr>
                              <th colSpan={2}>
                                <strong>Bank Details</strong>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {contactDetailsList.map((item, idx) => (
                              <>
                                {idx > 0 && (
                                  <tr key={`divider-${idx}`}>
                                    <td
                                      colSpan={2}
                                      style={{ backgroundColor: "#ebebeb", padding: "4px" }}
                                    ></td>
                                  </tr>
                                )}
                                {item.BeneficiaryName && (
                                  <tr key={`bname-${idx}`}>
                                    <td style={{ width: "50%" }}>
                                      <strong>Beneficiary Name</strong>
                                    </td>
                                    <td>{item.BeneficiaryName}</td>
                                  </tr>
                                )}
                                {item.AccountNo && (
                                  <tr key={`acc-${idx}`}>
                                    <td>
                                      <strong>Bank Account Number</strong>
                                    </td>
                                    <td>{item.AccountNo}</td>
                                  </tr>
                                )}
                                {item.BankName && (
                                  <tr key={`bank-${idx}`}>
                                    <td>
                                      <strong>Name of Bank</strong>
                                    </td>
                                    <td>{item.BankName}</td>
                                  </tr>
                                )}
                                {item.BankAddress && (
                                  <tr key={`bankaddr-${idx}`}>
                                    <td>
                                      <strong>Bank Address</strong>
                                    </td>
                                    <td>{item.BankAddress}</td>
                                  </tr>
                                )}
                                {item.BeneficiaryAddress && (
                                  <tr key={`benaddr-${idx}`}>
                                    <td>
                                      <strong>Beneficiary Address</strong>
                                    </td>
                                    <td>{item.BeneficiaryAddress}</td>
                                  </tr>
                                )}
                                {item.SwiftCode && (
                                  <tr key={`swift-${idx}`}>
                                    <td>
                                      <strong>Swift Code</strong>
                                    </td>
                                    <td>{item.SwiftCode}</td>
                                  </tr>
                                )}
                                {item.IFSC && (
                                  <tr key={`ifsc-${idx}`}>
                                    <td>
                                      <strong>RTGS/IFSC Code</strong>
                                    </td>
                                    <td>{item.IFSC}</td>
                                  </tr>
                                )}
                                {item.PanNo && (
                                  <tr key={`pan-${idx}`}>
                                    <td>
                                      <strong>PAN No</strong>
                                    </td>
                                    <td>{item.PanNo}</td>
                                  </tr>
                                )}
                                {item.GST && (
                                  <tr key={`gst-${idx}`}>
                                    <td>
                                      <strong>GST No</strong>
                                    </td>
                                    <td>{item.GST}</td>
                                  </tr>
                                )}
                              </>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>

                <div class="card-body p-0">
                  <form>
                    <div className="">
                      <label>Remark</label>
                      <textarea
                        class="form-control"
                        value={Remark}
                        onChange={(e) => this.setState({ Remark: e.target.value })}
                        disabled={is_View || isDeadlinePassed}
                        maxLength={300}
                        rows="3"
                      ></textarea>
                    </div>
                    <label class="mt-2">
                      <input
                        type="checkbox"
                        checked={Is_Agree}
                        disabled={is_View || isDeadlinePassed}
                        onChange={(e) =>
                          this.setState({ Is_Agree: e.target.checked, Is_AgreeErr: "" })
                        }
                      />
                      <span className="ms-1">
                        I confirm the above requirements and disclaimer.
                        <span className="required">*</span>
                      </span>
                    </label>
                    {Is_AgreeErr && (
                      <span className="text-danger text-start text-left d-block mt-1">
                        {Is_AgreeErr}
                      </span>
                    )}
                  </form>
                </div>
              </div>

              {!isHideSection && (
                <div className="row">
                  {currentDate > DeadlineDate && (
                    <span className="text-danger">
                      THE DEADLINE TO FILL OUT THE FORM HAS PASSED.
                    </span>
                  )}
                </div>
              )}

              <div className="row m-0">
                {!isHideSection && (
                  <div class="d-flex justify-content-end mt-0">
                    <button
                      type="button"
                      className="btn btn-aqua rounded-1 d-block mt-3 mb-3"
                      style={{ marginRight: 10 }}
                      disabled={isDeadlinePassed}
                      onClick={() =>
                        this.setState({
                          isOpenConfirmationModal: true,
                          confirmationObj: {
                            message: `Do you want to ${!isExistingForm ? "Save" : "Update"}?`,
                            buttonName: !isExistingForm ? "Save" : "Update",
                            action: 0,
                          },
                          popArg: [],
                        })
                      }
                    >
                      {!isExistingForm ? "Save" : "Update"}
                    </button>
                    <button
                      className="btn btn-gray rounded-1 d-block mt-3 mb-3"
                      onClick={() => this.handleCancel()}
                    >
                      Back
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(connect(null, { insertUpdateRentalAudioAndVideo_action, getRentalAudioAndVideoDetails_action })(RentalAudioAndVedioEquipment));
